<div class="flex flex-col max-w-120 min-w-120 max-h-screen -m-6">
  <!-- Header -->
  <div
    class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary"
  >
    <div class="text-lg font-medium">
      {{
        data?.user_email
          ? 'MFA Status for ' + data.user_email
          : 'MFA Status for ' + data?.user_id
      }}
    </div>
    <button mat-icon-button (click)="close()" [tabIndex]="-1">
      <mat-icon
        class="text-current"
        [svgIcon]="'heroicons_outline:x'"
      ></mat-icon>
    </button>
  </div>

  <div class="flex flex-col flex-auto p-6 overflow-y-auto">
    <!-- Loading -->
    <div *ngIf="isLoading" class="flex items-center justify-center p-8">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>

    <!-- Error -->
    <div
      *ngIf="!isLoading && errorMessage"
      class="text-red-500 text-center p-4"
    >
      Error: {{ errorMessage }}
    </div>

    <!-- Empty -->
    <div
      *ngIf="!isLoading && !errorMessage && enrollments.length === 0"
      class="text-center text-gray-500 p-8"
    >
      No MFA enrollments found.
    </div>

    <!-- Enrollment cards -->
    <div
      *ngFor="let enrollment of enrollments"
      class="border rounded-lg p-4 mb-3 last:mb-0"
    >
      <div class="flex items-center justify-between">
        <!-- Type icon + label -->
        <div class="flex items-center">
          <mat-icon
            class="icon-size-6 mr-3 text-gray-600"
            [svgIcon]="typeIcon(enrollment.type)"
          ></mat-icon>
          <div>
            <div class="font-semibold">{{ typeLabel(enrollment.type) }}</div>
            <div
              *ngIf="enrollment.phone_number"
              class="text-sm text-gray-500"
            >
              {{ enrollment.phone_number | phoneNumber }}
            </div>
          </div>
        </div>

        <!-- Confirmed badge -->
        <span
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
          [ngClass]="{
            'bg-green-100 text-green-800': enrollment.confirmed,
            'bg-yellow-100 text-yellow-800': !enrollment.confirmed
          }"
        >
          {{ enrollment.confirmed ? 'Confirmed' : 'Pending' }}
        </span>
      </div>

      <!-- Dates -->
      <div class="flex gap-6 mt-3 text-sm text-gray-500">
        <span>Enrolled: {{ enrollment.created_at | timeAgo }}</span>
        <span *ngIf="enrollment.last_auth_at"
          >Last used: {{ enrollment.last_auth_at | timeAgo }}</span
        >
      </div>

      <!-- SMS delivery status (phone enrollments only) -->
      <div
        *ngIf="enrollment.type === 'phone' && enrollment.sms_opt_out_status"
        class="mt-3 flex items-center justify-between"
      >
        <div class="flex items-center text-sm">
          <span
            class="inline-block w-2 h-2 rounded-full mr-2"
            [ngClass]="{
              'bg-green-500':
                enrollment.sms_opt_out_status === 'opted_in',
              'bg-red-500':
                enrollment.sms_opt_out_status === 'opted_out',
              'bg-gray-400':
                enrollment.sms_opt_out_status === 'unknown'
            }"
          ></span>
          <span
            *ngIf="enrollment.sms_opt_out_status === 'opted_in'"
            class="text-green-700"
            >SMS Opted In</span
          >
          <span
            *ngIf="enrollment.sms_opt_out_status === 'opted_out'"
            class="text-red-700"
            >SMS Opted Out</span
          >
          <span
            *ngIf="enrollment.sms_opt_out_status === 'unknown'"
            class="text-gray-500"
            >SMS Status Unknown</span
          >
        </div>

        <button
          *ngIf="enrollment.sms_opt_out_status === 'opted_out'"
          mat-stroked-button
          color="primary"
          [disabled]="optingInId === enrollment.id"
          (click)="optInSms(enrollment)"
        >
          <mat-spinner
            *ngIf="optingInId === enrollment.id"
            [diameter]="18"
            class="mr-2"
          ></mat-spinner>
          Opt In SMS
        </button>
      </div>

      <!-- AWS cooldown note -->
      <div
        *ngIf="
          enrollment.type === 'phone' &&
          enrollment.sms_opt_out_status === 'opted_out'
        "
        class="mt-2 text-xs text-gray-400"
      >
        Note: AWS enforces a 30-day cooldown after opt-out before opt-in takes
        effect.
      </div>
    </div>

    <!-- Reset MFA Section -->
    <div *ngIf="!isLoading && !errorMessage">
      <mat-divider class="my-4"></mat-divider>

      <!-- Reset button -->
      <button
        *ngIf="!showResetForm"
        mat-stroked-button
        color="warn"
        class="w-full"
        (click)="showReset()"
      >
        <mat-icon class="icon-size-5 mr-2" [svgIcon]="'mat_outline:undo'"></mat-icon>
        Reset All MFA Enrollments
      </button>

      <!-- Reset form -->
      <div *ngIf="showResetForm">
        <form [formGroup]="resetMfaEnrollmentForm">
          <mat-form-field class="w-full">
            <mat-label>Verification Details</mat-label>
            <textarea
              matInput
              formControlName="verification_details"
              placeholder="Provide the steps taken to verify the user's identity for MFA enrollment reset"
              rows="4"
            ></textarea>
            <mat-error
              *ngIf="
                resetMfaEnrollmentForm.controls['verification_details'].invalid
              "
              >User verification details are required to reset MFA
              enrollments</mat-error
            >
          </mat-form-field>
          <div class="flex justify-end gap-3 mt-2">
            <button
              mat-stroked-button
              (click)="cancelReset()"
              [disabled]="isResetting"
            >
              Cancel
            </button>
            <button
              mat-flat-button
              color="warn"
              (click)="resetMfa()"
              [disabled]="resetMfaEnrollmentForm.invalid || isResetting"
            >
              <mat-spinner
                *ngIf="isResetting"
                [diameter]="18"
                class="mr-2"
              ></mat-spinner>
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
